import './LoadingScreen.css';

function LoadingScreen({ className = '' }) {
  return (
    <div className={`loading-screen ${className}`}>
      <div className="loading-content">
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <p className="loading-text">Loading...</p>
      </div>
    </div>
  );
}

export default LoadingScreen;

